import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_all_payment_options_at_once~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_all_payment_options_at_once'
					),
			},
		},
	},
]

export default config
